const AgentLogo = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <svg
      width="80"
      height="110"
      viewBox="0 0 422 582"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{ overflow: "hidden" }}
    >
      <defs>
        <radialGradient
          cx="1158240"
          cy="0"
          r="1967541"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          id="fill0"
          gradientTransform="matrix(0.000360892 0 0 0.000360892 1373 343)"
        >
          <stop offset="0" stopColor="#B8E7FF" stopOpacity="1" />
          <stop offset="0.25" stopColor="#0099FF" stopOpacity="1" />
          <stop offset="0.4" stopColor="#5C7FFF" stopOpacity="1" />
          <stop offset="0.6" stopColor="#8575FF" stopOpacity="1" />
          <stop offset="0.8" stopColor="#962EFF" stopOpacity="1" />
          <stop offset="1" stopColor="#962EFF" stopOpacity="1" />
        </radialGradient>
      </defs>
      <g transform="translate(-1370 -339)">
        <g>
          <path
            d="M1396.92 571.242 1395.89 573.668 1396.92 574.096ZM1541.06 343.052 1541.06 552.678 1427.07 501.513 1427.07 586.635 1541.06 634.036 1541.06 890.87 1373 777.21 1373 777.21 1373 777.21 1373 524.87 1373.81 524.87 1373 518C1373 431.754 1444.64 359.796 1539.88 343.154ZM1622.33 343 1624.12 343.154C1719.36 359.796 1791 431.754 1791 518L1790.19 524.87 1791 524.87 1791 777.21 1790.98 777.21 1622.33 888.793 1622.33 634.898 1739.54 584.353 1738.51 505.603 1622.33 551.917Z"
            fill="url(#fill0)"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  </div>
);

export default AgentLogo;
